import { render, staticRenderFns } from "./FryPurchase.vue?vue&type=template&id=201cae3a&scoped=true&"
import script from "./FryPurchase.vue?vue&type=script&lang=js&"
export * from "./FryPurchase.vue?vue&type=script&lang=js&"
import style0 from "./FryPurchase.vue?vue&type=style&index=0&id=201cae3a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201cae3a",
  null
  
)

export default component.exports